import axios from 'axios';
import apiUrl from '../../constants';

export function getDatathroughShippingId(input, token){
    return axios({
       method: 'post',
       url: apiUrl.api_url + 'getshipmentdetails',
       data: input,
       headers: {
         'Authorization': 'Bearer ' + token
       }
     });
  }


// WEBPACK FOOTER //
// ./src/services/B2BModule/GetDataAPI.js